import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# 🗂️ راهنمای مدیریت نسخه‌های ساخت (Revisions)

پلتفرم کارخانه‌سازی میمزاد (Mimzad Manufacturing Platform) — سند راهنمای کاربری

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## 📋 معرفی صفحه جزئیات محصول

این صفحه مربوط به جزئیات یک خانواده محصول و تمام نسخه‌های ساخت (Revisions) آن است.

### نسخه‌ها (Revisions) چیست؟

در سیستم‌های مهندسی ساخت (PLM و ERP)، یک محصول ممکن است در طول زمان تکامل پیدا کند، مواد اولیه آن تغییر کند و یا قطعات جایگزین در آن به کار روند. برای مدیریت این تاریخچه بدون به هم ریختن اطلاعات قبلی، از **Revisions (نسخه‌ها)** استفاده می‌شود.

- **ایجاد نسخه جدید:** برای این محصول با کلیک روی **«➕ ساخت نسخه جدید»** یک نسخه (مثل `v1.0`) ایجاد کنید. این نسخه در حالت **پیش‌نویس (Draft)** قرار می‌گیرد.
- **وضعیت نسخه‌ها:**
  - `draft`: در حال تدوین (قابل تغییر).
  - `published`: نهایی شده و قابل استفاده در دستور کارهای تولید. هر محصول تنها یک نسخه Published می‌تواند داشته باشد.
  - `archived`: قدیمی و منقضی شده.

<Alert type="tip">
  برای اضافه کردن قطعات و ویرایش لیست مواد، روی دکمه **«ویرایش BOM»** در مقابل هر نسخه پیش‌نویس کلیک کنید تا وارد محیط حرفه‌ای ویرایشگر ساختار محصول شوید.
</Alert>
